// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { getCurrentAccountState } from "@insite/client-framework/Store/Data/Accounts/AccountsSelector";
import { CustomAppState } from "@steiner/App/Store/Reducers";

export function hasCustomAccountFieldsChanges(state: CustomAppState) {
    const { xAccount } = state;
    const account = getCurrentAccountState(state).value;
    if (!account || !xAccount) {
        return false;
    }

    return (
        account.firstName !== xAccount.firstName ||
        account.lastName !== xAccount.lastName ||
        account.properties?.company !== xAccount.company ||
        account.properties?.jobTitle !== xAccount.jobTitle ||
        account.properties?.phone !== xAccount.phone
    );
}
